import { PatientActions } from '../../../../actions/PatientActions';
import * as AppointmentRequirementActions from '../../AppointmentRequirementsActions';
import { APPOINTMENT_REQUIREMENTS_STRINGS } from '../../constants';
import * as Actions from './AddressFormActions';

export const initialState = {
    address1: '',
    address2: '',
    city: '',
    zip: '',
    selectedState: '',
    isValid: false,
    hasChanged: false,
    errors: {},
};

export default function addressFormReducer(state = initialState, action) {
    const { type, payload, errors } = action;

    switch (type) {
        case Actions.CHANGE_ADDRESS_1: {
            const newState = {
                ...state,
                address1: payload.address1,
                hasChanged: true,
                errors: {
                    ...state.errors,
                    address_line_1: undefined,
                },
            };

            return {
                ...newState,
                isValid: isValid(newState),
            };
        }
        case Actions.CHANGE_ADDRESS_2: {
            const newState = {
                ...state,
                address2: payload.address2,
                hasChanged: true,
                errors: {
                    ...state.errors,
                    address_line_2: undefined,
                },
            };

            return {
                ...newState,
                isValid: isValid(newState),
            };
        }
        case Actions.CHANGE_CITY: {
            const newState = {
                ...state,
                city: payload.city,
                hasChanged: true,
                errors: {
                    ...state.errors,
                    city: undefined,
                },
            };

            return {
                ...newState,
                isValid: isValid(newState),
            };
        }
        case Actions.CHANGE_ZIP: {
            const newState = {
                ...state,
                zip: payload.zip,
                hasChanged: true,
                errors: {
                    ...state.errors,
                    zip_code: undefined,
                },
            };

            return {
                ...newState,
                isValid: isValid(newState),
            };
        }
        case Actions.CHANGE_STATE: {
            const newState = {
                ...state,
                selectedState: payload.selectedState,
                hasChanged: true,
                errors: {
                    ...state.errors,
                    state: undefined,
                },
            };

            return {
                ...newState,
                isValid: isValid(newState),
            };
        }
        case PatientActions.PATIENT_RETRIEVED: {
            const { address } = payload;

            const newState = {
                ...state,
                address1: address.address_line_1,
                address2: address.address_line_2,
                city: address.city,
                zip: address.zip_code,
                selectedState: address.state,
            };

            return {
                ...newState,
                isValid: isValid(newState),
            };
        }
        case Actions.UPDATE_ADDRESS_FAILURE: {
            return {
                ...state,
                errors,
            };
        }
        case AppointmentRequirementActions.SHOW_VALIDATION_ERRORS: {
            return {
                ...state,
                errors: { ...buildValidationErrors(state) },
            };
        }
        default:
            return state;
    }
}

const buildValidationErrors = (state) => {
    const address1Error = !state.address1
        ? APPOINTMENT_REQUIREMENTS_STRINGS.AddressRequired
        : undefined;
    const cityError = !state.city
        ? APPOINTMENT_REQUIREMENTS_STRINGS.AddressRequired
        : undefined;
    const zipError = !state.zip
        ? APPOINTMENT_REQUIREMENTS_STRINGS.AddressRequired
        : undefined;
    const stateError = !state.selectedState
        ? APPOINTMENT_REQUIREMENTS_STRINGS.AddressRequired
        : undefined;

    return {
        address_line_1: address1Error,
        city: cityError,
        zip_code: zipError,
        state: stateError,
    };
};

const isValid = (address) => {
    return (
        !!address.address1 &&
        !!address.city &&
        !!address.zip &&
        !!address.selectedState
    );
};
